import {BankAccountDto} from "./BankAccountDto";
import {HelperFunctions} from "@/scripts/Common/HelperFunctions";

export class BankAccount {
    private bankAccountModel: BankAccountDto;

    public creditInstitute: string | undefined = '';
    public iban: string | undefined = '';
    public bic: string | undefined = '';
    public accountOwnerName: string | undefined = '';

    constructor(bankAccount?: BankAccountDto) {
        this.bankAccountModel = !!bankAccount ? bankAccount : new BankAccountDto();

        this.creditInstitute = this.bankAccountModel.creditInstitute;
        this.iban = this.bankAccountModel.iban;
        this.bic = this.bankAccountModel.bic;
        this.accountOwnerName = this.bankAccountModel.accountOwnerName;
    }

    public Reset() {
        this.creditInstitute = this.bankAccountModel.creditInstitute;
        this.iban = this.bankAccountModel.iban;
        this.bic = this.bankAccountModel.bic;
        this.accountOwnerName = this.bankAccountModel.accountOwnerName;
    }

    get HasChanges() {
        return this.creditInstitute != this.bankAccountModel.creditInstitute ||
            this.iban != this.bankAccountModel.iban ||
            this.bic != this.bankAccountModel.bic ||
            this.accountOwnerName != this.bankAccountModel.accountOwnerName;
    }

    public GetModel() {
        let model = new BankAccountDto();

        model.id = this.bankAccountModel.id;
        model.creditInstitute = this.creditInstitute;
        model.iban = this.iban;
        model.bic = this.bic;
        model.accountOwnerName = this.accountOwnerName;

        return model;
    }

    public SetValues(bankAccount: BankAccountDto) {
        this.bankAccountModel = bankAccount
        this.creditInstitute = bankAccount.creditInstitute;
        this.iban = bankAccount.iban;
        this.bic = bankAccount.bic;
        this.accountOwnerName = bankAccount.accountOwnerName;
    }

    public isModelEmpty() {
        return HelperFunctions.isEmpty(this.creditInstitute) &&
            HelperFunctions.isEmpty(this.iban) &&
            HelperFunctions.isEmpty(this.bic) &&
            HelperFunctions.isEmpty(this.accountOwnerName);
    }
}
